import {ClientConfiguration} from "../configuration/client.config";
import {DebugService} from "../debug/debug.service";
import {Injectable} from "@angular/core";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {PipelineService} from "../pipeline/pipeline.service";

@Injectable()
export class KeyboardService {

    constructor(private config: ClientConfiguration,
                private debugService:DebugService,
                private pipelineService:PipelineService,
                private log: BugsnagLoggingService) {
    }

    onKey(event: KeyboardEvent): void {
        let value = event.key;
        this.log.log("key pressed: " + value);

        if (this.config.allowDebugKeys && DebugService.isDebugKey(value)) {
            this.log.log("Debug key pressed: " + value);
            this.debugService.handleKeyboardEvent(event);
        }

        if (this.config.isSuperUserMode && PipelineService.isSuperKey(value)) {
            this.log.log("Pipeline key pressed: " + value);
            this.pipelineService.handleKeyboardEvent(event);
        }
    }
}
